import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExpiryStateStore } from '../../core/store/expiry-date.store';
import { ExpiryDialogComponent } from './expiry-dialog/expiry-dialog';

@Component({
  selector: 'emma-expiry-selector',
  imports: [CommonModule,MatSelectModule,MatFormFieldModule,MatOptionModule,ExpiryDialogComponent,MatTooltipModule],
  standalone: true,
  templateUrl: './expiry.html',
  styleUrls: ['./expiry.scss'],
})
export class ExpirySelectorComponent{
  public readonly expiryStateService = inject(ExpiryStateStore);
  
  constructor(
    public dialog: MatDialog,
    private readonly overlayContainer: OverlayContainer
  ) {
    this.overlayContainer.getContainerElement().classList.add('e-selector-overlay');
  }

  public tooltipText = computed(() => {
    const selectedDate = this.expiryStateService.selectedExpiryDate();
    return selectedDate 
      ? `Expiry Date : ${this.formatDate(selectedDate)}`
      : 'Expiry Date';
  });

  public openDialog(): void {
    const dialogRef = this.dialog.open(ExpiryDialogComponent, {
      panelClass: 'e-selector-postion-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.selectedDate) {
      }
    });
  }

  public formatDate(date: Date): string {
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}
